import { render } from "./IconTrekBrakeCoaster.vue?vue&type=template&id=10cc93a3"
import script from "./IconTrekBrakeCoaster.vue?vue&type=script&lang=js"
export * from "./IconTrekBrakeCoaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__